module.exports = __webpack_public_path__ + "assets/img/techstars_logo_colored.aab1ac3e.png";